import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { AppSettings } from "../AppSettings";
import AppHelper from "../Helper/AppHelper";
import { Role } from "../Interface/Role";
import { Service } from "../Interface/Service";
import { UserDetail } from "../Interface/UserDetail";

import Loader from "./Loader";

import { useTheme } from "@mui/material/styles";
import { User } from "../Interface/IUser";
import { Message } from "../Interface/Message";
import AlertBox from "./CommonComponent/AlertBox";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

function Services() {
  const [openLoader, setOpenloader] = React.useState(false);
  const [userInfo, setUsersInfo] = React.useState<UserDetail>({
    id: 0,
    isActive: true,
    role: {
      id: 0,
      name: "",
      description: "",
      isActive: true,
      services: [
        {
          id: 0,
          name: "",
          description: "",
          serviceSSOLink: "",
          iconName: "",
          priority: "0",
          imageSrc: "",
          imageFile: null,
          isActive: true,
          isAdminActive: true,
        },
      ],
    },
  });

  const [alertBoxmsg, setAlertBoxmsg] = React.useState<Message>({
    Type: "",
    Text: "",
  });
  const navigate = useNavigate();

  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    AppHelper.isUserLogin();
    if (useEffectCount.current) {
      useEffectCount.current = false;
      getUserDetails();
    }
  }, []);

  function getUserDetails() {
    setOpenloader(true);

    let userID = AppHelper.getUser().id;
    setOpenloader(true);
    let apiUrl =
      AppSettings.API_URL + "User/GetUserRolesAndServices?id=" + userID;
    fetch(apiUrl, AppHelper.requestOptions("POST"))
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then((data) => {
        if (data != undefined) {
          let user: UserDetail = data || " ";

          if (user.isActive) {
            if (!user.role.isActive) {
              let msg = {
                Text: "No active role is assigned to your account!",
                Type: "Error",
              };
              setAlertBoxmsg(msg);
              return;
            }
            if (user.role.services == null) {
              let msg = {
                Text: "No active services are assigned to your account!",
                Type: "Error",
              };
              setAlertBoxmsg(msg);
              return;
            }

            setUsersInfo(user);
          } else {
            localStorage.removeItem("user-info-lpa");
            window.location.href = "/";
          }
        }
      })
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
        }
      })
      .finally(() => {
        setOpenloader(false);
      });
  }

  const theme = useTheme();
  return (
    <div>
      <Loader value={openLoader}></Loader>
      <p className="page-heading">Choose Your Service</p>
      <div className="services-items">
        {alertBoxmsg.Text !== "" ? (
          <>
            <div className="msg-div">
              <AlertBox value={alertBoxmsg}></AlertBox>{" "}
            </div>
          </>
        ) : (
          <>
            {" "}
            {openLoader ? (
              <></>
            ) : (
              <Grid container spacing={2}>
                {userInfo.role.services.map((item, index) => (
                  <Grid item xs={12} sm={6} md={6} key={index}>
                    <a
                      href={item.serviceSSOLink}
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      {" "}
                      <Box sx={{ minWidth: 270 }}>
                        <Card
                          variant="outlined"
                          sx={{
                            minHeight: 185,
                            ":hover": {
                              cursor: "pointer",
                              transform: "scale(1.02)",
                            },
                          }}
                          //  onClick={() => handleClick(item)}
                        >
                          <Grid container spacing={1} pt={3}>
                            <Grid xs={3}>
                              <img
                                src={item.imageSrc}
                                className="service-icon"
                              ></img>
                            </Grid>
                            <Grid xs={9}>
                              <React.Fragment>
                                <CardContent className="service-text">
                                  <Typography
                                    component="div"
                                    variant="h6"
                                    className="service-name"
                                  >
                                    {item.name}
                                  </Typography>
                                  <Typography className="service-details">
                                    {item.description}
                                  </Typography>
                                </CardContent>
                              </React.Fragment>
                            </Grid>
                          </Grid>
                        </Card>
                      </Box>{" "}
                    </a>
                  </Grid>
                ))}
              </Grid>
            )}
          </>
        )}
      </div>

      <div className="blank-div"></div>
    </div>
  );
}

export default Services;
